import axios from 'axios'

export default {
  async getUser() {
    return await axios.get('/users/account_info')
  },
  async updateTanakaId(body) {
    return await axios.patch('users/update_tanaka_id', body)
  },
  async updateAccountInfo(body) {
    return await axios.patch('users/update_account_info', body)
  },
}
